import { PdEditContent } from "./pd-edit-content/PdEditContent.js";
//#region src/pd-edit-content/pd-edit-content.ts
var tag = "pd-edit-content";
if (!customElements.get(tag)) customElements.define(tag, PdEditContent);
//#endregion
export { PdEditContent };
